import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import Button from "../../../../shared/button/Button";
import {
  ButtonsWrapper,
  ActionConfirmation,
  ActionConfimationIcon,
  ActionConfirmationMessage,
} from "../styles/withdraw-candidate-styles";

const WithdrawalActionConfirmation = ({
  handleCancel,
  handleActionConfirmation,
}) => (
  <ActionConfirmation>
    <ActionConfimationIcon>
      <FontAwesomeIcon icon={faExclamationCircle} />
    </ActionConfimationIcon>
    <ActionConfirmationMessage>
      Are you sure you want to <span>withdraw</span> this candidate and
      <span> cancel</span> current <span>job offer</span>?
    </ActionConfirmationMessage>
    <ButtonsWrapper>
      <Button secondary buttonName="No" onClickAction={handleCancel} />
      <Button
        primary
        buttonName="Yes"
        onClickAction={handleActionConfirmation}
      />
    </ButtonsWrapper>
  </ActionConfirmation>
);

WithdrawalActionConfirmation.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  handleActionConfirmation: PropTypes.func.isRequired,
};

export default WithdrawalActionConfirmation;
